import { useState, useEffect } from 'react';
import posthog from '@libs/posthog';

const read = (key: string): string | undefined => {
  const value = posthog.getFeatureFlag(key);
  return typeof value === 'string' ? value : undefined;
};

export function useFeatureFlagVariant(key: string): string | undefined {
  const [variant, setVariant] = useState<string | undefined>(() => read(key));

  useEffect(() => {
    return posthog.onFeatureFlags(() => {
      setVariant(read(key));
    });
  }, [key]);

  return variant;
}
